import React from 'react';
import '../cfcDashboard/DashboardHeader.scss';

/**
 * ConsumerBaseLoading Component
 * 
 * A placeholder loading component for the consumer base section of the dashboard.
 * It renders a styled div to indicate loading.
 *
 * @component
 * @component
 * @memberof Components
 * @example
 * return (
 *   <ConsumerBaseLoading />
 * )
 *
 * @returns {JSX.Element} A div styled as a loading placeholder.
 */
const ConsumerBaseLoading = () => {

    return (
        <div className="dashboard-header" style={{ width: '47.5vw', height: '25vh', backgroundColor: '#edeff2' }}>
        </div>
    )
};

export default ConsumerBaseLoading;
